import { inr, num } from "../../lib/format";

export const diffLabel = (d) => (d < 0 ? `Short ${num(-d)}` : d > 0 ? `Excess ${num(d)}` : "None");
export const diffClass = (d) => (d < 0 ? "text-destructive" : d > 0 ? "text-amber-600 dark:text-amber-400" : "text-muted-foreground");

export const GRNItemCard = ({ item, index, onChange }) => {
  const inv = Number(item.qty_invoice) || 0;
  const rec = Number(item.qty_received) || 0;
  const diff = rec - inv;
  const value = rec * item.rate;
  const tax = (value * item.gst) / 100;
  const t = `grn-item-${index}`;
  return (
    <div className="panel rise space-y-3 p-4" data-testid={`grn-item-card-${index}`}>
      <div>
        <p className="font-semibold">{index + 1}. {item.description}{item.colour ? ` (${item.colour})` : ""} {item.code && <span className="mono text-xs text-muted-foreground">[{item.code}]</span>}</p>
        <p className="mono text-xs text-muted-foreground">{inr(item.rate)} / {item.uom} · {item.gst}% GST</p>
      </div>
      <div className="grid grid-cols-2 gap-2 rounded-lg bg-muted/60 p-3 text-sm">
        <div><p className="mono-label text-muted-foreground">PO qty</p><p className="mono font-semibold" data-testid={`${t}-po-qty`}>{num(item.qty_po)} {item.uom}</p></div>
        <div><p className="mono-label text-muted-foreground">PO balance</p><p className="mono font-semibold" data-testid={`${t}-balance`}>{num(item.qty_balance)} {item.uom}</p></div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="min-w-0">
          <label className="label">Qty as per invoice</label>
          <input className="field mono" type="number" inputMode="decimal" min="0" step="any" value={item.qty_invoice}
            onChange={(e) => onChange({ qty_invoice: e.target.value })} data-testid={`${t}-invoice-qty-input`} />
        </div>
        <div className="min-w-0">
          <label className="label">Qty received</label>
          <input className="field mono" type="number" inputMode="decimal" min="0" step="any" value={item.qty_received}
            onChange={(e) => onChange({ qty_received: e.target.value })} data-testid={`${t}-received-qty-input`} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div className="min-w-0"><p className="mono-label text-muted-foreground">Difference</p><p className={`mono truncate font-bold ${diffClass(diff)}`} data-testid={`${t}-difference`}>{diffLabel(diff)}</p></div>
        <div className="min-w-0"><p className="mono-label text-muted-foreground">Value</p><p className="mono truncate font-medium" data-testid={`${t}-value`}>{inr(value)}</p></div>
        <div className="min-w-0"><p className="mono-label text-muted-foreground">Tax</p><p className="mono truncate font-medium" data-testid={`${t}-tax`}>{inr(tax)}</p></div>
      </div>
      {rec > item.qty_balance && <p className="text-xs font-semibold text-amber-600 dark:text-amber-400" data-testid={`${t}-over-balance`}>Received is more than the PO balance</p>}
      {inv > item.qty_balance && <p className="text-xs font-semibold text-destructive" data-testid={`${t}-invoice-over-po`}>3-way mismatch: invoice qty is more than the PO balance</p>}
    </div>
  );
};
